import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from '@material-ui/styles';
import moment from "moment";

import I18n from "../../../base/i18n.js";

import SeparatorBlock from "./components/separator_block.js";
import TopInfoBlock from "./components/top_info_block.js";
import ValuesBlock from "./components/values_block.js";
import InvestInfoBlock from "./components/invest_info_block.js";
import ProjectsBlock from "./components/projects_block";
import ManagersBlock from "./components/managers_block";
import ReviewsBlock from "./components/reviews_block";
import SubscribeBlock from "./components/subscribe_block.js";

import { ProjectsAnchor } from "./constants.js";

const blockStyles = makeStyles(theme => ({
}));

const IndexPage = (props) => {
  const classes = blockStyles();

  const [recoveredAt, setRecoveredAt] = useState(moment().unix());

  const { cacheLifecycles } = props;
  if(cacheLifecycles) {
    cacheLifecycles.didRecover(() => {
      setRecoveredAt(moment().unix());
    })
  }

  return (
    <div className = { classes.root } >
      <TopInfoBlock />
      <ValuesBlock />
      <InvestInfoBlock />
      <SeparatorBlock title = { I18n.t("web.page.index.foundation.title")}/>

      <ProjectsBlock id = { ProjectsAnchor }
                     recoveredAt = { recoveredAt } />
      <ManagersBlock />
      {/* <SeparatorBlock title = { I18n.t("web.page.index.trade_space.title")}
                      text = { I18n.t("web.page.index.trade_space.text")} /> */}
      <ReviewsBlock />
      <SubscribeBlock />
    </div>
  );
};

export default IndexPage;